export default __webpack_public_path__ + "static/media/TaptDesignTemplate.d66052a7.ai";